var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"position-x":_vm.x,"position-y":_vm.y,"absolute":"","offset-y":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-list',_vm._l((_vm.menuItems),function(item){return _c('v-list-tile',{key:item.key,on:{"click":function($event){return _vm.selectMenuItem(item.key)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.text))])],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-608f1c8c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewer/edition/components/TableDataMenu.vue
// module id = 2177
// module chunks = 0